import React, { useState, useEffect } from 'react';
import { Typography, Button, MenuItem, TextField } from '@mui/material';
import MostrarError from '../../components/AccionesPartes/MostrarError';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
    const [info, setInfo] = useState(null);
    const [infoHotel, setInfoHotel] = useState(null);
    const [hotelesLista, setHotelesLista] = useState([]); // Todos los hoteles
    const [hotelTrabajo, setHotelTrabajo] = useState(0);

    let hoteles = localStorage.getItem('hoteles');
    let listaHoteles = JSON.parse(hoteles);

    const [primer, setPrimer] = useState(false);
    const [variosHoteles, setVariosHoteles] = useState(false);

    const fd = new FormData();
    const requestOptions = {
        method: 'POST',
        body: fd
    };

    window.history.replaceState({}, document.title, '/#/Home');

    const getCantidadPartes = () => {
        fd.append("f", "partes.getCantidadPartes");
        fd.append("token", localStorage.getItem('token'));
        fetch('https://api.workers.grupotel.com/', requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setInfo(data);
                //console.log(data);
            })
            .catch((error) => {
                MostrarError('Error al obtener la información de la API', error);
            });
    };

    // Guardamos la cantidad de hoteles.
    const getInfoHotel = (idHotel = 0) => {
        fd.append("f", "hotel.getInfoHotel");
        fd.append("token", localStorage.getItem('token'));
        if (idHotel == 0) {
            fd.append("id_hotel", hotelTrabajo);
        } else {
            fd.append("id_hotel", idHotel);
        }

        fetch('https://api.workers.grupotel.com/', requestOptions)
            .then((response) => response.json())
            .then((data) => {
                let error = data.error;
                if (error.id === 0) {
                    setInfoHotel(data.info);
                    console.log(data.info);
                } else {
                    setInfoHotel(null);
                    MostrarError(error.msg);
                    console.log(error.msg);
                }
            })
            .catch((error) => {
                MostrarError('Error al obtener la información de la API', error);
            });
    };

    const getHoteles = () => {
        if (listaHoteles && listaHoteles.length > 0) {
            setHotelesLista(listaHoteles);

            if (listaHoteles.length === 1) {
                setHotelTrabajo(listaHoteles[0].value);
                getInfoHotel(listaHoteles[0].value);
                setVariosHoteles(false);
            } else {
                let hotelSelec = localStorage.getItem('idHotelSeleccionado');
                if (hotelSelec) {
                    setHotelTrabajo(hotelSelec);
                    getInfoHotel(hotelSelec);
                } else {
                    setHotelTrabajo(listaHoteles[0].value);
                    getInfoHotel(listaHoteles[0].value);
                }
                setVariosHoteles(true);
            }
        }
    };

    const cambiaHotelTrabajo = async (event) => {
        if (event.target.name === 'id_hotel') {
            const idHotel = event.target.value;
            setHotelTrabajo(idHotel);

            if (idHotel && idHotel != 0) {
                getInfoHotel(idHotel);
            }
        }
    };

    useEffect(() => {
        if (!primer) {
            getHoteles();
            setPrimer(true);
        }
        getCantidadPartes();
    }, []);

    return (
        <div>
            <div className='header'>
                <h1 className='centrar'>HOME</h1>
            </div>
            <div className='homeContainer'>
                <div className='homeContainerHeader'>
                    <Typography variant="h5" component="div" className='centrar'>
                        Información Partes
                    </Typography>
                </div>
                {info !== null ? (
                    <div className='containerButtonContainer'>
                        <Link to="/Partes/Entradas/nuevo" className='enlaces-button'>
                            <Button className="nuevo-button custom-button">
                                <span className="custom-button-text">{info.nuevos}</span>
                                <span className="custom-button-label">Nuevos</span>
                            </Button>
                        </Link>
                        <Link to="/Partes/Entradas/ejecucion" className='enlaces-button'>
                            <Button className="en-ejecucion-button custom-button">
                                <span className="custom-button-text">{info.ejecucion}</span>
                                <span className="custom-button-label">Ejecución</span>
                            </Button>
                        </Link>
                        <Link to="/Partes/Entradas/asignado" className='enlaces-button'>
                            <Button className="asignado-button custom-button">
                                <span className="custom-button-text">{info.asignado}</span>
                                <span className="custom-button-label">Asignado</span>
                            </Button>
                        </Link>
                        <Link to="/Partes/Entradas/terceros" className='enlaces-button'>
                            <Button className="terceros-button custom-button">
                                <span className="custom-button-text">{info.terceros}</span>
                                <span className="custom-button-label">Terceros</span>
                            </Button>
                        </Link>
                        <Link to="/Partes/Entradas/aplazados" className='enlaces-button'>
                            <Button className="nuevo-button custom-button">
                                <span className="custom-button-text">{info.aplazados}</span>
                                <span className="custom-button-label">Aplazados</span>
                            </Button>
                        </Link>
                    </div>
                ) : null}

            </div>
            <br />
            <div className='homeContainer'>
                <div className='homeContainerHeader'>
                    <Typography variant="h5" component="div" className='centrar'>
                        Información Hotel
                    </Typography>
                </div>
                {
                    variosHoteles == true ?
                        <div className='homeContainerHeader'>
                            <TextField
                                className='nuevoParteTextfield'
                                variant="outlined"
                                margin="normal"
                                label="Hotel"
                                name="id_hotel"
                                size="small"
                                value={hotelTrabajo ? hotelTrabajo : ""}
                                onChange={cambiaHotelTrabajo}
                                select
                                SelectProps={{
                                    MenuProps: {
                                        PaperProps: {
                                            sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                        }
                                    }
                                }}
                            >
                                {hotelesLista.map((hotel) => (
                                    <MenuItem key={hotel.value} value={hotel.value} >
                                        {hotel.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </div>
                        : <div className='homeContainerHeader'>
                            <h3 style={{ textAlign: "center" }}> {listaHoteles[0].label}</h3>
                        </div>
                }

                {infoHotel !== null && infoHotel.length > 1 ? (
                    <div className="info-hotel-container info-hotel-general" >

                        {/* HOY */}
                        <div className="columna-hotel">
                            <h3 style={{ textAlign: "center" }}> HOY ({new Date(infoHotel[1].fecha)
                                .toLocaleDateString("es-ES")
                            }) </h3>
                            <div className="fila">
                                {/* <div className="box">
                                    <strong>Check-In</strong>
                                    <div>{infoHotel[1].checkin}</div>
                                </div> */}
                                <div className="box">
                                    <strong>Check-In {/*Total*/}
                                    </strong>
                                    <div>{infoHotel[1].checkinTotal}</div>
                                </div>
                                {/* // CheckOut Pendiente 
                                <div className="box box-divider">
                                    <strong>Check-Out</strong>
                                    <div>{infoHotel[1].checkout}</div>
                                </div> */}
                                <div className="box">
                                    <strong>Check-Out {/*Total*/}

                                    </strong>
                                    <div>{infoHotel[1].checkoutTotal}</div>
                                </div>
                            </div>
                            <div className="fila">
                                <div className="box">
                                    <strong>Desayuno</strong>
                                    <div>{infoHotel[1].desayuno}</div>
                                </div>
                                <div className="box">
                                    <strong>Comida</strong>
                                    <div>{infoHotel[1].comida}</div>
                                </div>
                                <div className="box">
                                    <strong>Cena</strong>
                                    <div>{infoHotel[1].cena}</div>
                                </div>
                                <div className="box">
                                    <strong>Total Alojados</strong>
                                    <div>{infoHotel[1].totalPersonas}</div>
                                </div>
                            </div>
                        </div>

                        {/* MAÑANA */}
                        <div className="columna-hotel">
                            <h3 style={{ textAlign: "center" }}> MAÑANA ({new Date(infoHotel[0].fecha)
                                .toLocaleDateString("es-ES")
                            }) </h3>
                            <div className="fila">
                                {/* <div className="box">
                                    <strong>Check-In</strong>
                                    <div>{infoHotel[0].checkin}</div>
                                </div> */}
                                <div className="box">
                                    <strong>Check-In {/*Total*/}
                                    </strong>
                                    <div>{infoHotel[0].checkinTotal}</div>
                                </div>
                                {/* <div className="box box-divider">
                                    <strong>Check-Out</strong>
                                    <div>{infoHotel[0].checkout}</div>
                                </div> */}
                                <div className="box">
                                    <strong>Check-Out {/*Total*/}
                                    </strong>
                                    <div>{infoHotel[0].checkoutTotal}</div>
                                </div>
                            </div>
                            <div className="fila">
                                <div className="box">
                                    <strong>Desayuno</strong>
                                    <div>{infoHotel[0].desayuno}</div>
                                </div>
                                <div className="box">
                                    <strong>Comida</strong>
                                    <div>{infoHotel[0].comida}</div>
                                </div>
                                <div className="box">
                                    <strong>Cena</strong>
                                    <div>{infoHotel[0].cena}</div>
                                </div>
                                <div className="box">
                                    <strong>Total Alojados</strong>
                                    <div>{infoHotel[0].totalPersonas}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
}
export default Home;